const howItWorksMap = [
  {
    id: 1,
    subtitle: "Sign Up and Create Your Profile",
    description:
      "Getting started with BikeConnectGlobal is a breeze. Simply download the app, sign up," +
      " and create your unique profile. Share your riding experiences, upload a profile picture" +
      " of you and your beloved bike, and let the community know what kind of adventures you're into.",
  },
  {
    id: 2,
    subtitle: "Discover and Connect",
    description:
      "Once your profile is set up, start exploring the world of motorcycle adventures. Browse" +
      " through a diverse range of user-generated content, from scenic ride photos to detailed" +
      " route descriptions. Discover riders who share your interests, and send them a friend" +
      " request to kickstart a new riding connection.",
  },
  {
    id: 3,
    subtitle: "Plan Your Adventure",
    description:
      "Ready to hit the road? Use BikeConnectGlobal to plan your next epic journey. Explore a" +
      " map of user-recommended routes and destinations, complete with insider tips and photos." +
      " Create your own routes and share them with the community to inspire fellow riders.",
  },
  {
    id: 4,
    subtitle: "Share Your Stories",
    description:
      "Every ride has a story, and we make it easy to share yours. Capture the highlights of" +
      " your adventures through photos, videos, and engaging captions. Whether it's a stunning" +
      " sunset over a mountain pass or a roadside encounter with friendly locals, share your" +
      " experiences with the world.",
  },
  {
    id: 5,
    subtitle: "Connect with Riders",
    description:
      "Engage in conversations with fellow riders through private messages and group chats." +
      " Discuss route details, exchange travel tips, and arrange meet-ups with newfound riding" +
      " companions. Turn strangers into friends who'll share the thrill of the open road.",
  },
  {
    id: 6,
    subtitle: "Stay Informed",
    description:
      "Stay up-to-date with the latest motorcycle news, gear reviews, and riding events. Our" +
      " platform keeps you informed about upcoming rallies, charity rides, and other biking" +
      " events in your area.",
  },
  {
    id: 7,
    subtitle: "Safety First",
    description:
      "BikeConnectGlobal is committed to rider safety. Share safety tips, equipment" +
      " recommendations, and maintenance advice with the community. Encourage responsible riding" +
      " practices and help others stay safe on their journeys.",
  },
  {
    id: 8,
    subtitle: "Build Your Riding Legacy",
    description:
      "Over time, your profile will become a digital scrapbook of your riding experiences." +
      " Build a legacy of adventures, friendships, and wisdom to inspire both yourself and" +
      " others.",
  },
  {
    id: 9,
    subtitle: "Community Support",
    description:
      "Whether you're seeking advice, support, or just some riding camaraderie, you'll find it" +
      " within our supportive and welcoming community. We're here to celebrate your victories" +
      "and provide encouragement during challenges.",
  },
  {
    id: 10,
    subtitle: "Spread the Love",
    description:
      "Help us grow our community by inviting your fellow riders to join BikeConnectGlobal. The" +
      " more, the merrier, as we share our passion for motorcycles, exploration, and forming" +
      "connections with strangers who become lifelong friends.",
  },
];

export default howItWorksMap;
